/**
 * Central registry of application-config feature flags.
 *
 * Server keys are ticket ids (e.g. "TA-11941"). Add a readable name here when a
 * feature needs to gate on a flag, then use `useFeatureFlag` / `isFeatureEnabled`.
 * Remove the entry when the flag is retired from application-config.
 *
 * A flag is on when any of these enable it (query > cookie > config):
 * - application-config `featureFlags` in the fetch response
 * - cookie `TA-11941=true` (set from DevTools)
 * - query param `?TA-11941=true` on the active URL (`?TA-11941` also enables)
 *
 * @example
 * // 1. Register
 * MY_FEATURE: "AM-1234"
 *
 * // 2. React
 * const enabled = useFeatureFlag(FeatureFlag.MY_FEATURE)
 *
 * // 3. Non-React (actions, utils)
 * if (isFeatureEnabled(config, FeatureFlag.MY_FEATURE)) { ... }
 * if (isCachedFeatureEnabled(FeatureFlag.MY_FEATURE)) { ... }
 */
export const FeatureFlag = {
  /** Sanctions Screening tab on the loan page (shared MF remote, TA-11924 / TA-11925). */
  OFAC_SCREENING: "TA-11941"
} as const;

export type FeatureFlagName = keyof typeof FeatureFlag;
export type FeatureFlagId = (typeof FeatureFlag)[FeatureFlagName];
